import { url } from '@fiverr-private/futile';

/**
 * Mutates the Gig data object
 * @param  {Object} gigData           Gig data object
 * @param  {Object} [options]
 * @param  {Object} [options.context] Context object
 * @return {Object} gigData           Mutated object
 */
export const adaptGigData = (gigData, {context} = {}) => {
    if (!context) {
        return gigData;
    }

    return [
        'gig_url',
        'seller_url'
    ].reduce((gigData, item) => {
        gigData[item] = addRefCtxId(gigData[item], context);

        return gigData;
    }, gigData);
};

/**
 * Add ref_ctx_id to URL where applicable
 * @param {String} url
 * @param {Object} [context={}]
 * @param {String} [context.refCtxId]
 * @param {String} [context.pageCtxId]
 */
const addRefCtxId = (uri, context = {}) => {
    const ref_ctx_id = context.refCtxId || context.pageCtxId;

    if (!ref_ctx_id) {
        return uri;
    }

    return new url.URI(uri)
        .addParams({ref_ctx_id})
        .href;
};



// WEBPACK FOOTER //
// ./src/utils/adaptGigData/index.js